import { motion } from "framer-motion";
import { MANIFESTO } from "@/data";

export default function WhyChooseUs() {
  return (
    <section id="why" className="py-24 sm:py-32 scroll-mt-20 bg-card border-y border-border">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-16 max-w-2xl">
          <span className="text-accent font-bold text-sm tracking-widest uppercase">Why Choose Us</span>
          <h2 className="font-display font-extrabold text-4xl sm:text-6xl mt-3 tracking-tight text-primary">
            Dog carers you can trust
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-x-16 gap-y-14">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`manifesto-${m.n}`}
              className="flex gap-6 items-start border-t-2 border-border pt-8"
            >
              <span className="font-display font-extrabold text-5xl sm:text-6xl text-secondary leading-none">
                {m.n}
              </span>
              <div>
                <h3 className="font-display font-extrabold text-2xl mb-2 text-primary">{m.title}</h3>
                <p className="text-muted-foreground leading-relaxed font-medium">{m.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
